import { render } from "./DFormCheck.vue?vue&type=template&id=31c3009e"
import script from "./DFormCheck.vue?vue&type=script&lang=js"
export * from "./DFormCheck.vue?vue&type=script&lang=js"

import "./DFormCheck.vue?vue&type=style&index=0&id=31c3009e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__